(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["information-page-sidebar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.sidebar-menu__mobile-dropdown[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('ss-collection-product-count')) {
    customElements.define('ss-collection-product-count', class extends HTMLElement {
      connectedCallback() {
        this.sync = this.syncCount.bind(this);
        document.addEventListener('DOMContentLoaded', this.sync, { once: true });
        document.addEventListener('collection:rerendered', this.sync);
        document.addEventListener('shopify:section:load', this.sync);
        this.syncCount();
      }

      syncCount() {
        if (!this.isConnected) return;
        const source = document.getElementById('ProductCount');
        if (source !== this.source) {
          this.observer?.disconnect();
          this.source = source;
          if (source) {
            this.observer = new MutationObserver(this.sync);
            this.observer.observe(source, { childList: true, subtree: true, characterData: true });
          }
        }
        const count = source?.textContent.trim();
        if (count) {
          const text = `(${count})`;
          if (this.textContent !== text) this.textContent = text;
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.source = null;
        document.removeEventListener('DOMContentLoaded', this.sync);
        document.removeEventListener('collection:rerendered', this.sync);
        document.removeEventListener('shopify:section:load', this.sync);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subcollection-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ss-collection-navigation')) {
    customElements.define('ss-collection-navigation', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.container = this.querySelector('[data-subcollection-container]');
        this.track = this.querySelector('[data-subcollection-scroll]');
        this.previous = this.querySelector('[data-subcollection-prev]');
        this.next = this.querySelector('[data-subcollection-next]');
        if (!this.container || !this.track || !this.previous || !this.next) return;
        this.initialized = true;
        this.renderedURL = this.pageURL();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onUpdate = () => {
          cancelAnimationFrame(this.updateFrame);
          this.updateFrame = requestAnimationFrame(() => this.update());
        };
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onRerender = () => this.refresh();
        this.onClick = event => this.followFilter(event);
        this.previous.addEventListener('click', this.onPrevious);
        this.next.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onUpdate, { passive: true });
        this.track.addEventListener('click', this.onClick);
        if (this.dataset.source === 'productsoorten') {
          document.addEventListener('collection:rerendered', this.onRerender);
          window.addEventListener('popstate', this.onRerender);
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onUpdate);
          this.observeSizes();
        } else {
          window.addEventListener('resize', this.onUpdate);
        }
        document.fonts?.ready.then(() => {
          if (this.isConnected && this.initialized) this.onUpdate();
        });
        this.update();
      }

      pageURL() {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        return url.toString();
      }

      observeSizes() {
        if (!this.resizeObserver) return;
        this.resizeObserver.disconnect();
        this.resizeObserver.observe(this.track);
        Array.from(this.track.children).forEach(item => this.resizeObserver.observe(item));
      }

      update() {
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.max(0, Math.min(max, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft));
        const before = max > 2 && position > 1;
        const after = max > 2 && position < max - 1;
        this.container.classList.toggle('is-overflowing', max > 2);
        this.container.classList.toggle('can-scroll-prev', this.rtl ? after : before);
        this.container.classList.toggle('can-scroll-next', this.rtl ? before : after);
        this.previous.disabled = !before;
        this.next.disabled = !after;
        if (max > 2) this.track.tabIndex = 0;
        else this.track.removeAttribute('tabindex');
      }

      move(direction) {
        this.track.scrollBy({
          left: direction * (this.rtl ? -1 : 1) * Math.max(240, Math.round(this.track.clientWidth * .7)),
          behavior: this.motion.matches ? 'auto' : 'smooth'
        });
      }

      findFilterLink(param, value) {
        return Array.from(this.track.querySelectorAll('[data-product-type-link]')).find(link =>
          link.dataset.filterParam === param && link.dataset.filterValue === value
        );
      }

      async followFilter(event) {
        const link = event.target.closest('[data-product-type-link]');
        if (!link || !this.track.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const getForm = () => Array.from(document.querySelectorAll('form[is="facet-form"]')).find(form =>
          typeof form.renderSection === 'function' && form.dataset.sectionId
        );
        // Keep the real link as a fallback when Hyper's filter form is unavailable.
        if (!getForm()) return;
        event.preventDefault();
        const error = this.querySelector('[data-subcollection-error]');
        if (error) error.hidden = true;
        const { filterParam, filterValue } = link.dataset;
        try {
          // Refresh stale links first so other filters and sorting stay selected.
          while (this.renderedURL !== this.pageURL()) {
            const refreshed = await this.refresh();
            if (!refreshed) throw new Error('Filter link refresh failed');
            if (!this.isConnected) return;
          }
          if (!this.isConnected) return;
          const currentLink = this.findFilterLink(filterParam, filterValue);
          const form = getForm();
          if (!currentLink) return;
          if (!form) throw new Error('Filter form unavailable');
          const url = new URL(currentLink.href, window.location.href);
          url.searchParams.delete('sections');
          url.searchParams.delete('page');
          url.searchParams.set('section_id', form.dataset.sectionId);
          // Hyper updates products, counts, selected values and the URL without a page reload.
          // Its collection:rerendered event then refreshes this navigation row.
          form.renderSection(url.toString(), event);
        } catch (cause) {
          if (error && this.isConnected) {
            error.textContent = 'Het filter kon niet worden bijgewerkt. Probeer opnieuw.';
            error.hidden = false;
          }
        }
      }

      refresh() {
        if (!this.initialized || this.dataset.source !== 'productsoorten') return Promise.resolve(false);
        const pageURL = this.pageURL();
        if (this.refreshPromise && this.requestedURL === pageURL) return this.refreshPromise;
        this.abortController?.abort();
        if (this.renderedURL === pageURL) return Promise.resolve(true);
        const controller = new AbortController();
        this.abortController = controller;
        this.requestedURL = pageURL;
        const url = new URL(pageURL);
        url.searchParams.set('section_id', this.dataset.sectionId);
        this.setAttribute('aria-busy', 'true');
        this.refreshPromise = (async () => {
          try {
            const response = await fetch(url.toString(), { signal: controller.signal });
            if (!response.ok) throw new Error('Navigation refresh failed');
            const html = await response.text();
            if (controller.signal.aborted || !this.isConnected || pageURL !== this.pageURL()) return false;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = Array.from(doc.querySelectorAll('ss-collection-navigation')).find(element =>
              element.dataset.sectionId === this.dataset.sectionId
            );
            const freshTrack = fresh?.querySelector('[data-subcollection-scroll]');
            if (!fresh || !freshTrack) throw new Error('Navigation missing from response');
            freshTrack.querySelectorAll('[data-product-type-link]').forEach(link => {
              const linkURL = new URL(link.getAttribute('href'), pageURL);
              linkURL.searchParams.delete('section_id');
              linkURL.searchParams.delete('sections');
              link.setAttribute('href', linkURL.pathname + linkURL.search + linkURL.hash);
            });
            const focused = this.track.contains(document.activeElement) ? document.activeElement : null;
            const focusedParam = focused?.dataset.filterParam;
            const focusedValue = focused?.dataset.filterValue;
            const scrollLeft = this.track.scrollLeft;
            this.track.innerHTML = freshTrack.innerHTML;
            this.track.setAttribute('aria-label', freshTrack.getAttribute('aria-label') || 'Productsoorten');
            this.hidden = fresh.hidden;
            this.querySelector('[data-navigation-notice]')?.remove();
            const notice = fresh.querySelector('[data-navigation-notice]');
            if (notice) this.prepend(notice);
            this.track.scrollLeft = scrollLeft;
            this.renderedURL = pageURL;
            this.observeSizes();
            this.update();
            if (focused && !this.hidden) {
              (this.findFilterLink(focusedParam, focusedValue) || this.track).focus({ preventScroll: true });
            }
            return true;
          } catch (error) {
            return false;
          } finally {
            if (this.abortController === controller) {
              this.refreshPromise = null;
              this.removeAttribute('aria-busy');
            }
          }
        })();
        return this.refreshPromise;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.updateFrame);
        this.abortController?.abort();
        if (!this.initialized) return;
        this.previous.removeEventListener('click', this.onPrevious);
        this.next.removeEventListener('click', this.onNext);
        this.track.removeEventListener('scroll', this.onUpdate);
        this.track.removeEventListener('click', this.onClick);
        document.removeEventListener('collection:rerendered', this.onRerender);
        window.removeEventListener('popstate', this.onRerender);
        window.removeEventListener('resize', this.onUpdate);
        this.resizeObserver?.disconnect();
        this.initialized = false;
        this.refreshPromise = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
